/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from '@apollo/client/react/components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { gql } from '@apollo/client';
import { object } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { compose } from 'recompose';

import { GRAPHQL_ENV } from '../../../gql';
import * as app from '../../../../state/ducks/App';
import RadioPageBlock from './RadioPageBlock';

const brandSelectors = app.ducks.brand.selectors;

const GraphqlRadioPage = ({ brand, page }) => {
    const RADIOFORM_QUERY = gql`
        query RadioPageQuery {
            findContent(brand: "${brand['domain-name']}",  environment: "${GRAPHQL_ENV}", locale: "en-us", contentType: "radio_host_form") {
                content
            }
        }
    `;

    return (
        <Query query={RADIOFORM_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null; // skeleton component
                }

                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: RADIOFORM_QUERY,
                        component: 'GraphqlRadioPage.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: RADIOFORM_QUERY,
                        component: 'GraphqlRadioPage.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                if (!data.findContent?.content) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: RADIOFORM_QUERY,
                        component: 'GraphqlRadioPage.js',
                        message: 'No content returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                const contentData = data.findContent?.content?.entries?.[0] || null;
                return (
                    <>
                        {contentData && <RadioPageBlock page={page} data={contentData} /> }
                    </>
                );
            }}
        </Query>
    );
};

GraphqlRadioPage.propTypes = {
    brand: object.isRequired,
    page: object.isRequired,
};

const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps),
);

export default enhance(GraphqlRadioPage);
